/**
 * Обвязка над Telegram Mini App SDK: initData для авторизации в нашем API,
 * тема, кнопка «назад», хаптика.
 *
 * Вне Telegram (обычный браузер при разработке) SDK недоступен — тогда берём
 * initData из `VITE_DEV_INIT_DATA`, чтобы экраны можно было гонять локально.
 */
import { retrieveLaunchParams } from '@telegram-apps/sdk';

export interface TelegramEnv {
  initData: string;
  /** Внутри Telegram или в обычном браузере. */
  inTelegram: boolean;
  colorScheme: 'dark' | 'light';
}

let cached: TelegramEnv | null = null;

export function telegramEnv(): TelegramEnv {
  if (cached) return cached;

  try {
    const params = retrieveLaunchParams();
    const raw = (params as { initDataRaw?: string }).initDataRaw ?? '';
    if (raw.length > 0) {
      cached = { initData: raw, inTelegram: true, colorScheme: 'dark' };
      return cached;
    }
  } catch {
    // не в Telegram — падаем на dev-режим ниже
  }

  cached = {
    initData: import.meta.env['VITE_DEV_INIT_DATA'] ?? '',
    inTelegram: false,
    colorScheme: 'dark',
  };
  return cached;
}

/** Тактильный отклик на нажатие; вне Telegram — тихо ничего не делает. */
export function haptic(style: 'light' | 'medium' | 'rigid' = 'light'): void {
  const webApp = (globalThis as { Telegram?: { WebApp?: { HapticFeedback?: { impactOccurred(style: string): void } } } })
    .Telegram?.WebApp;
  webApp?.HapticFeedback?.impactOccurred(style);
}

/** Разворачивает окно на всю высоту — иначе Mini App открывается «половинкой». */
export function expandViewport(): void {
  const webApp = (globalThis as { Telegram?: { WebApp?: { expand(): void; ready(): void } } }).Telegram
    ?.WebApp;
  webApp?.ready();
  webApp?.expand();
}

/** Открыть внешнюю ссылку (депозит/вывод у брокера) правильным способом. */
export function openLink(url: string): void {
  const webApp = (globalThis as { Telegram?: { WebApp?: { openLink(url: string): void } } }).Telegram
    ?.WebApp;
  if (webApp?.openLink) webApp.openLink(url);
  else globalThis.open(url, '_blank', 'noopener');
}
